import FunctionsData from "../../../Functions/FunctionsData";
import * as React from "react";
import {useEffect, useState} from "react";
import {Switch} from "@mui/material";

export default function CampaignsShowVets({campaignData, addVets, setAddVets, dataFiltered}) {

    const campaignPostcodes = String(campaignData?.postcodes).split(',');

    function fn(e, id) {

        let v = addVets;

        if (e.currentTarget.checked === true) {
            v = [...v, id];
        } else {
            v = addVets.filter(itm => itm !== id);
        }

        let vUnique = [...new Set([...v])];

        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/campaign/') + campaignData.id,
            {additional_vets: vUnique.join(',')}
        ).then((r) => {
            setAddVets([...vUnique]);
            // setLoading(true);
        })

    }

    return (
        <div>
            {
                dataFiltered && dataFiltered.map((r) => {
                    return (
                        <ShowVetSwitch addVets={addVets} row={r} fn={fn} campaignPostcodes={campaignPostcodes}/>
                    )
                })
            }
        </div>
    )
}

const ShowVetSwitch = ({row, addVets, campaignPostcodes, fn}) => {

    const [isIncluded, setIsIncluded] = useState(true);
    const [checked, setChecked] = useState(true);

    useEffect(() => {

        try {

            setChecked(addVets.includes((row.id)));

            let i = false;
            campaignPostcodes.forEach((x) => {
                if (parseInt(x) === parseInt(row.postcode)) i = true;
            });
            setIsIncluded(i);
        } catch (e) {
            setIsIncluded(false);
        }

    }, [addVets]);

    if (isIncluded === true) return null;
    if (row.active === 0 || row.postcode === '' || row.postcode === null) return null;
    return (
        <div>
            <Switch checked={(checked === true) ? "checked" : ""} onChange={(e) => fn(e, row.id)}/>
            {row.business_name} ({row.postcode})
        </div>
    )

}
